import styled from 'styled-components';

import { ReactComponent as Arrow } from 'assets/images/arrow-forw.svg';
import { ReactComponent as Chevron } from 'assets/images/chevron-bold.svg';

export const Container = styled.div`
  margin: 70px 16px 16px 28px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  @media ${({ theme }) => theme.device.desktop} {
    margin-top: 10px;
  }
`;

export const Cards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  gap: 16px;

  background: #ffffff;
  box-shadow: 0px 5px 10px rgba(33, 34, 36, 0.04);
  border-radius: 8px;
`;

export const Header: any = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #b8b4b4;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

Header.Detail = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
  gap: 16px;
`;

Header.Button = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  color: #332927;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

Header.Chevron = styled(Chevron)`
  height: 24px;
  color: #332927;
  margin-right: -8px;
`;

type DividerProps = {
  $dark?: boolean;
};
export const Divider = styled.div<DividerProps>`
  background-color: ${({ $dark }) => ($dark ? '#DBDBDB' : '#F4F4F4')};
  width: 100%;
  height: 1px;
`;

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;
export const Itinerary = styled.div`
  display: flex;
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  color: #332927;
  align-items: center;
`;
export const ArrowIcon = styled(Arrow)`
  width: 16px;
  height: 16px;
  margin: 0 8px;
`;
export const Line = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  & span {
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;
    color: #332927;
  }
`;
export const Total = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  & span {
    font-weight: 600;
    font-size: 14px;
    line-height: 140%;
    color: #332927;
  }
`;
export const Timeline: any = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 18px;
  padding-top: 18px;
`;
Timeline.Dot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 6px;
  margin: 9px 0;
  background: #332927;
`;
Timeline.Line = styled.div`
  height: 340px;
  width: 1px;
  margin: 0 2px;
  background: #332927;
`;
